module.exports = "<p>\r\n  applicationsapprovals works!\r\n</p>\r\n"